import load from 'little-loader';
import captureException from './captureException';
import retry from './retry';

declare global {
  interface Window {
    recaptchaLoaded: () => void;
  }
}

type Recaptcha = typeof window.grecaptcha;

type RecaptchaCallbackArgs = {
  grecaptcha: Recaptcha;
};
type RecaptchaCallback = (args: RecaptchaCallbackArgs) => void;

const GOOGLE_RECAPTCHA_API = 'https://www.google.com/recaptcha/enterprise.js';
export const RECAPTCHA_COOKIE_NAME = 'g-recaptcha-response';
const NOT_LOADED = 0;
const LOADING = 1;
const LOADED = 2;

const queue: RecaptchaCallback[] = [];
let state = NOT_LOADED;
let grecaptcha: Recaptcha | null = null;

const loadRecaptchaSdk = (callback: RecaptchaCallback): void => {
  if (typeof window !== 'undefined') {
    window.recaptchaLoaded = () => {
      state = LOADED;
      grecaptcha = window.grecaptcha;
      while (queue.length > 0) {
        queue.pop()?.({ grecaptcha });
      }
    };

    if (state === LOADED && grecaptcha != null) {
      callback({ grecaptcha });
    } else if (state === LOADING) {
      queue.push(callback);
    } else {
      state = LOADING;
      queue.push(callback);

      const params = new URLSearchParams({
        render: process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITE_KEY || '',
        onload: 'recaptchaLoaded',
      });

      const url = `${GOOGLE_RECAPTCHA_API}?${params.toString()}`;

      const loader = () => new Promise((resolve, reject) => {
        load(url, (err: unknown) => (err ? reject() : resolve(undefined)));
      });

      retry(3, loader, async () => {
        captureException(new Error("Action failed because reCAPTCHA isn't loaded"));
      });
    }
  }
};

export default loadRecaptchaSdk;
